import { IconPhotoFrameOutline18 as FrameIcon } from "nucleo-ui-outline-18"

import type {} from "@productlane/lib/src/tiptap/extensions/mintlify/frame"

import type { SlashCommandDefinition } from "../../types"
import { iconClassName } from "../../constants"

export const frameCommand: SlashCommandDefinition = {
	key: "frame",
	title: "Frame",
	icon: <FrameIcon strokeWidth={1.75} className={iconClassName} />,
	command: ({ editor, range }) => {
		editor.chain().focus().deleteRange(range).insertFrame().run()
	},
	group: "blocks",
	aliases: ["frame", "caption", "screenshot", "image frame", "figure"],
}
